module.exports = __webpack_public_path__ + "img/组1071.fa820db8.png";